<template>
  <div class="container flex pb-24 pl-6 pr-6 lg1024:pl-0 lg1024:pr-0">
    <div class="w-full lg1024:border-r lg1024:border-themeGray pt-8">
      <section v-if="newsMessage" class="breadcrumbsContainer py-2">
        <div class="breadcrumbs row_line">
          <a href="/">{{ mainPageMessage }}</a>
          <i class="mdi mdi-chevron-right"></i>
          <a href="/news/">{{ newsMessage }}</a>
          <i class="mdi mdi-chevron-right"></i>
          <span>{{ smiMessage }}</span>
        </div>
      </section>
      <div class="font-bold text-2xl">{{ titleMessage }}</div>
      <div v-if="rendered">
        <template v-if="posts.length">
          <PostsGrid :layout="'rows'" :posts="posts"/>
          <div v-if="next" class="py-8 flex items-center justify-center">
            <Loader v-if="loadNextPage"/>
            <button v-else class="productButtonLink" @click="onNext">{{ nextPageMessage }}</button>
          </div>
        </template>
        <div v-else class="flex justify-center relative mt-20">{{ errorMessage }}</div>
      </div>
      <div v-else class="min-h-screen flex justify-center relative">
        <Loader/>
      </div>
    </div>
    <SidebarWidget :position="'right'" v-if="rendered" class="hidden lg1024:flex"/>
  </div>
</template>

<script>
import PostsGrid from "../components/PostsGrid.vue";
import Loader from "../components/Loader.vue";
import SidebarWidget from "../components/SidebarWidget.vue";
import NewList from "../mixins/NewList";

export default {
  name: 'PressCenter',
  components: {
    Loader,
    PostsGrid,
    SidebarWidget
  },
  props: {
    inCategory: {
      default: 269
    },
    currentUrl: {
      default: "СМИ о нас"
    },
    inName: {
      default: "smi"
    }
  },
  data() {
    return {
      category: this.inCategory
    }
  },
  mixins: [NewList],
  computed: {
    titleMessage() {
      return this.$store.getters.getTranslation("press_center");
    },
    errorMessage() {
      return this.$store.getters.getTranslation("no_posts_in_category");
    },
    newsMessage() {
      return this.$store.getters.getTranslation("news");
    },
    mainPageMessage() {
      return this.$store.getters.getTranslation("main_page");
    },
    smiMessage() {
      return this.$store.getters.getTranslation(this.inName);
    }
  },
  mounted() {

    this.$store.commit("changeCurrentUrl", this.currentUrl);
    this.listMounted()
    this.initEventScroll()

    const time = setInterval(() => {
      const title = this.$store.getters.getTitle
      const description = this.$store.getters.getDescription
      const header = this.$store.getters.getHeader

      if ('main' in title) {
        if (
            this.$props.inCategory in title &&
            title[this.$props.inCategory] &&
            title[this.$props.inCategory] !== 'none'
        ) {
          document.querySelector('title').innerText = title[this.$props.inCategory]
          document.querySelector('meta[name="description"]').innerText = description[this.$props.inCategory]
          this.$store.commit('updateHeaderFocus', header[this.$props.inCategory])
        } else {
          document.querySelector('title').innerText = 'Coral News'
          document.querySelector('meta[name="description"]').innerText = ''
          this.$store.commit('updateHeaderFocus', 'none')
        }

        clearInterval(time)
      }
    }, 240)
  }
}
</script>

<style scoped></style>
